export default "__VITE_ASSET__6b287bd2__"